import React from 'react';
import _ from "lodash";
import clsx from "clsx";

import {Slider} from '@material-ui/core';

import useStyles from './styles'

function Steps(props) {

  const { value, handleChange } = props;

  const classes = useStyles();

  const isUnselected = _.every(value, v => v === '');

  return (
    <Slider
      marks={props.marks}
      min={1}
      max={7}
      step={null}
      value={isUnselected ? [1, 1] : value}
      onChange={handleChange}
      style={props.style}
      classes={{
        rail: classes.sliderRail,
        track: classes.sliderTrack,
        mark: classes.mark,
        markActive: !isUnselected && classes.markActive,
        root: classes.root,
        markLabelActive: !isUnselected && classes.markLabelActive,
        markLabel: classes.markLabe,
        thumb: clsx(classes.thumb, isUnselected && 'hidden'),
      }}
    />
  )
}

Steps.propTypes = {

}

export default Steps

